module.exports = __webpack_public_path__ + "static/img/sp_banner3.3d521b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sp/sp_banner3.png
// module id = y6lv
// module chunks = 0